import React from 'react';
import A16z from './Investors/A16z';
import AnimocaBrands from './Investors/AnimocaBrands';
import Avalanche from './Investors/Avalanche';
import BrevanHoward from './Investors/BrevanHoward';
import CoinbaseVentures from './Investors/CoinbaseVentures';
import Dapper from './Investors/Dapper';
import Dragonfly from './Investors/Dragonfly';
import ForesightVentures from './Investors/ForesightVentures';
import Galaxy from './Investors/Galaxy';
import GriffinGamingPartners from './Investors/GriffinGamingPartners';
import Hashed from './Investors/Hashed';
import Inception from './Investors/Inception';
import IOSGVentures from './Investors/IOSGVentures';
import LibertyCity from './Investors/LibertyCity';
import Lightspeed from './Investors/Lightspeed';
import NGCVentures from './Investors/NGCVentures';
import Polygon from './Investors/Polygon';
import Sfermion from './Investors/Sfermion';
import MainLogo, { MainLogoProps } from './MainLogo/MainLogo';
import MainLogoLetters from './MainLogoLetters/MainLogoLetters';

export const logoIcons: LogoIconsInterface = {
	mainlogo: MainLogo,
	mainlogoletters: MainLogoLetters,
	a16z: A16z,
	animocabrands: AnimocaBrands,
	avalanche: Avalanche,
	brevanhoward: BrevanHoward,
	coinbaseventures: CoinbaseVentures,
	dapper: Dapper,
	dragonfly: Dragonfly,
	foresightventures: ForesightVentures,
	galaxy: Galaxy,
	griffingamingpartners: GriffinGamingPartners,
	hashed: Hashed,
	inception: Inception,
	iosgventures: IOSGVentures,
	libertycity: LibertyCity,
	lightspeed: Lightspeed,
	ngcventures: NGCVentures,
	polygon: Polygon,
	sfermion: Sfermion,
};

export interface LogoIconsInterface {
	mainlogo: ({
		additionalText,
		className,
		logoType,
	}: MainLogoProps) => React.JSX.Element;
	mainlogoletters: React.FC<React.SVGProps<SVGSVGElement>>;
	a16z: React.FC<React.SVGProps<SVGSVGElement>>;
	animocabrands: React.FC<React.SVGProps<SVGSVGElement>>;
	avalanche: React.FC<React.SVGProps<SVGSVGElement>>;
	brevanhoward: React.FC<React.SVGProps<SVGSVGElement>>;
	coinbaseventures: React.FC<React.SVGProps<SVGSVGElement>>;
	dapper: React.FC<React.SVGProps<SVGSVGElement>>;
	dragonfly: React.FC<React.SVGProps<SVGSVGElement>>;
	foresightventures: React.FC<React.SVGProps<SVGSVGElement>>;
	galaxy: React.FC<React.SVGProps<SVGSVGElement>>;
	griffingamingpartners: React.FC<React.SVGProps<SVGSVGElement>>;
	hashed: React.FC<React.SVGProps<SVGSVGElement>>;
	inception: React.FC<React.SVGProps<SVGSVGElement>>;
	iosgventures: React.FC<React.SVGProps<SVGSVGElement>>;
	libertycity: React.FC<React.SVGProps<SVGSVGElement>>;
	lightspeed: React.FC<React.SVGProps<SVGSVGElement>>;
	ngcventures: React.FC<React.SVGProps<SVGSVGElement>>;
	polygon: React.FC<React.SVGProps<SVGSVGElement>>;
	sfermion: React.FC<React.SVGProps<SVGSVGElement>>;
}
